var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading"
            }
          ],
          staticClass: "rounded",
          attrs: {
            "empty-text": "Nenhum distribuidor encontrado.",
            data: _vm.data,
            align: "center",
            border: "",
            "row-key": "id",
            "expand-row-keys": _vm.expandedRows
          },
          on: { "expand-change": _vm.handleExpand }
        },
        [
          _c("el-table-column", {
            attrs: { type: "expand" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _c("div", {}, [
                    _c(
                      "div",
                      { staticClass: "px-3" },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 12 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 10 } },
                              [
                                _c(
                                  "el-card",
                                  [
                                    _c(
                                      "el-descriptions",
                                      {
                                        attrs: {
                                          title: "Informações",
                                          column: 4,
                                          size: "mini",
                                          border: true
                                        }
                                      },
                                      [
                                        _c("template", { slot: "extra" }, [
                                          _c(
                                            "div",
                                            { staticClass: "d-flex" },
                                            [
                                              _vm.isAuthorized
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "success",
                                                        size: "mini",
                                                        plain: "",
                                                        disabled: _vm.isLoading
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.dispatchLoginAs(
                                                            scope.row.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.isLoading
                                                        ? _c("i", {
                                                            staticClass:
                                                              "el-icon-loading"
                                                          })
                                                        : _c("i", {
                                                            staticClass:
                                                              "fas fa-sign-in-alt"
                                                          }),
                                                      _vm._v(
                                                        "\n                                                Logar como\n                                            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.isAuthorized
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "warning",
                                                        size: "mini",
                                                        plain: "",
                                                        disabled: _vm.isLoading
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.dispatchChangePassword(
                                                            scope.row.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.isLoading
                                                        ? _c("i", {
                                                            staticClass:
                                                              "el-icon-loading"
                                                          })
                                                        : _c("i", {
                                                            staticClass:
                                                              "fas fa-key"
                                                          }),
                                                      _vm._v(
                                                        "\n                                                Alterar senha\n                                            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "el-descriptions-item",
                                          { attrs: { span: 4 } },
                                          [
                                            _c("template", { slot: "label" }, [
                                              _vm._v("Distribuidor")
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center justify-content-between"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(scope.row.nome))
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center"
                                                  },
                                                  [
                                                    _c(
                                                      "el-tag",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          type: "info",
                                                          size: "mini"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "#" +
                                                            _vm._s(
                                                              scope.row.codigo
                                                            )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "mini",
                                                          circle: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.copyThis(
                                                              scope.row.codigo
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-document-copy"
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-descriptions-item",
                                          { attrs: { span: 4 } },
                                          [
                                            _c("template", { slot: "label" }, [
                                              _vm._v("Classe")
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "el-tag",
                                              { attrs: { size: "mini" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.classe || "-"
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.distributor &&
                                        _vm.distributor.pessoa_fisica
                                          ? _c(
                                              "el-descriptions-item",
                                              { attrs: { span: 4 } },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "label" },
                                                  [_vm._v("CPF")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center justify-content-between"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      [
                                                        _vm.isLoading
                                                          ? _c("el-skeleton")
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .distributor
                                                                    .pessoa_fisica
                                                                    .cpf || "-"
                                                                )
                                                              )
                                                            ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.distributor.cpf
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              size: "mini",
                                                              circle: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.copyThis(
                                                                  _vm
                                                                    .distributor
                                                                    .pessoa_fisica
                                                                    .cpf
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-document-copy"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              2
                                            )
                                          : _vm.distributor &&
                                            _vm.distributor.pessoa_juridica
                                          ? _c(
                                              "el-descriptions-item",
                                              { attrs: { span: 4 } },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "label" },
                                                  [_vm._v("CNPJ")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center justify-content-between"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.distributor
                                                            .pessoa_juridica
                                                            .cnpj || "-"
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                    _vm.distributor
                                                      .pessoa_juridica.cnpj
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              size: "mini",
                                                              circle: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.copyThis(
                                                                  _vm
                                                                    .distributor
                                                                    .pessoa_juridica
                                                                    .cnpj
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-document-copy"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 14 } },
                              [
                                _c(
                                  "el-card",
                                  [
                                    _c(
                                      "el-descriptions",
                                      {
                                        attrs: {
                                          title: "Contato",
                                          column: 4,
                                          size: "mini",
                                          border: true
                                        }
                                      },
                                      [
                                        _c("template", { slot: "extra" }, [
                                          _c("div", { staticClass: "d-flex" }, [
                                            _vm.isLoading
                                              ? _c("i", {
                                                  staticClass: "el-icon-loading"
                                                })
                                              : _vm._e()
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "el-descriptions-item",
                                          { attrs: { span: 4 } },
                                          [
                                            _c("template", { slot: "label" }, [
                                              _c("i", {
                                                attrs: {
                                                  clsas: "fas fa-envelope"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                                            E-mail\n                                        "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center justify-content-between"
                                              },
                                              [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    attrs: {
                                                      type: "info",
                                                      size: "mini"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.email || "-"
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      circle: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.copyThis(
                                                          scope.row.email
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-document-copy"
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.distributor &&
                                        _vm.distributor.contatos.length > 0
                                          ? _vm._l(
                                              _vm.distributor.contatos,
                                              function(contact, index) {
                                                return _c(
                                                  "el-descriptions-item",
                                                  {
                                                    key: contact.id,
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "label" },
                                                      [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              contact.telefone
                                                                .tipo == "F"
                                                                ? "Fixo"
                                                                : "Celular"
                                                            ) +
                                                            "\n                                            "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center justify-content-between"
                                                      },
                                                      [
                                                        _c(
                                                          "el-tag",
                                                          {
                                                            attrs: {
                                                              size: "mini"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "(" +
                                                                _vm._s(
                                                                  contact
                                                                    .telefone
                                                                    .ddd
                                                                ) +
                                                                ") " +
                                                                _vm._s(
                                                                  contact
                                                                    .telefone
                                                                    .numero
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              size: "mini",
                                                              circle: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.copyThis(
                                                                  "(" +
                                                                    contact.ddd +
                                                                    ")$ {contact.numero}"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-document-copy"
                                                            })
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  2
                                                )
                                              }
                                            )
                                          : _c(
                                              "el-descriptions-item",
                                              { attrs: { span: 4 } },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "label" },
                                                  [_vm._v("Contatos")]
                                                ),
                                                _vm._v(
                                                  "\n                                        -\n                                    "
                                                )
                                              ],
                                              2
                                            ),
                                        _vm._v(" "),
                                        _vm.distributor &&
                                        _vm.distributor.endereco
                                          .endereco_formatado
                                          ? _c(
                                              "el-descriptions-item",
                                              { attrs: { span: 4 } },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "label" },
                                                  [
                                                    _vm._v(
                                                      "\n                                            Endereço\n                                        "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.distributor.endereco
                                                        .endereco_formatado
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.isAuthorized
            ? _c("el-table-column", {
                attrs: { label: "ID", width: "80", prop: "id", align: "left" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return _c("div", {}, [_vm._v(_vm._s(scope.row.id))])
                      }
                    }
                  ],
                  null,
                  false,
                  544699632
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "#Código", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.codigo))])]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { "min-width": "320", label: "Nome", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.nome))])]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Classe", width: "70", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-tag", { attrs: { size: "small" } }, [
                      _vm._v(_vm._s(scope.row.classe))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Cidade/Estado", width: "220", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.cidade) + " - " + _vm._s(scope.row.uf)
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Status", width: "140", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.status
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "small",
                              type:
                                scope.row.status === "Ativo"
                                  ? "success"
                                  : scope.row.status == "Inativo"
                                  ? "warning"
                                  : "danger"
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(scope.row.status.toUpperCase()) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Criado em", width: "110", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-center"
                      },
                      [
                        _c("i", { staticClass: "el-icon-time" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-1" }, [
                          _vm._v(_vm._s(_vm.formatDate(scope.row.created_at)))
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Última atualização",
              width: "160",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-center"
                      },
                      [
                        _c("i", { staticClass: "el-icon-time" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-1" }, [
                          _vm._v(_vm._s(_vm.formatDate(scope.row.updated_at)))
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: { fixed: "right", width: 50, align: "right" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "bottom-end",
                                trigger: "hover"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "reference",
                                    size: "mini",
                                    type: "info",
                                    plain: "",
                                    circle: "",
                                    disabled: _vm.isLoading
                                  },
                                  slot: "reference"
                                },
                                [_c("i", { staticClass: "el-icon-more" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  style: {
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                    gap: "4px",
                                    maxWidth: "300px"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Ações")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-divider", { staticClass: "my-1" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { style: { width: "100%" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            plain: "",
                                            disabled: _vm.isLoading
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.goToShowPage(
                                                scope.row.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-right"
                                          }),
                                          _vm._v(
                                            "\n                                    Ver Distribuidor\n                                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.isAuthorized
                                    ? _c(
                                        "div",
                                        { style: { width: "100%" } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              style: { width: "100%" },
                                              attrs: {
                                                size: "mini",
                                                type: "success",
                                                plain: "",
                                                disabled: _vm.isLoading
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.dispatchLoginAs(
                                                    scope.row.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-sign-in-alt"
                                              }),
                                              _vm._v(
                                                "\n                                    Logar como\n                                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticStyle: { width: "100%" },
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_c("i", { staticClass: "el-icon-menu" })]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "mt-3" },
        [
          _c(
            "el-col",
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pagination.data.currentPage,
                  "page-sizes": _vm.pagination.pageSizes,
                  "page-size": _vm.pagination.data.perPage,
                  layout: "total, sizes, prev, pager, next",
                  total: _vm.pagination.total
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pagination.data, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pagination.data, "currentPage", $event)
                  },
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("DistribuidorChangePassword", { ref: "changePassword" }),
      _vm._v(" "),
      _c("DistribuidorLoginAs", { ref: "loginAs" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45c0aa53", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45c0aa53","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/distribuidor/DistribuidorList.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-45c0aa53","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_internal/distribuidor/DistribuidorList.vue
// module chunks = 2